import React, { useContext, useMemo, useState } from 'react';
import SearchBarWithFilter from '../../../../../VentoryUI/components/common/SearchBarWithFilter';
import { AddButton, Button } from '../../../../components/Button';
import { t } from '../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { Icon } from '../../../../icons';
import { IconType } from '../../../../icons/Icon';
import CreateCompanyConnectionModal from '../Modals/CreateCompanyConnectionModal';
import { CompanyConnectionContext } from '../../../../../context/CompanyConnectionContext';
import { CompanyConnectionFilter } from '../../../../../VentoryUI/components/filters/CompanyConnectionFilter/CompanyConnectionFilter';
import { CompanyContext } from '../../../../../context/CompanyContext';
import PartnerCard from '../Common/PartnerCard';
import UpdateCompanyConnectionModal from '../Modals/UpdateCompanyConnectionModal';
import { CompanyConnection } from '../../../../../types/companyConnection/companyConnection';
import CreateCompanyAsPartnerModal from '../Modals/CreateCompanyAsPartnerModal';

interface PartnerOverviewPaneProps {}

export default function PartnerOverviewPane({}: PartnerOverviewPaneProps) {
  const { companies } = useContext(CompanyContext);
  const { companyConnections, companyConnectionsLoading } = useContext(CompanyConnectionContext);

  const [items, setItems] = useState([...companyConnections.values()]);

  const [selected, setSelected] = useState<CompanyConnection | undefined>(undefined);

  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false);
  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openCompanyModal, setOpenCompanyModal] = useState<boolean>(false);

  const allItems = useMemo(() => {
    return [...companyConnections.values()];
  }, [companyConnections]);

  const filter = new CompanyConnectionFilter(companies);

  return (
    <>
      {openCreateModal && <CreateCompanyConnectionModal open={openCreateModal} setOpen={setOpenCreateModal} />}
      {openUpdateModal && selected && (
        <UpdateCompanyConnectionModal
          open={openUpdateModal}
          setOpen={open => {
            setOpenUpdateModal(open);
            setSelected(undefined);
          }}
          connection={selected}
        />
      )}
      {openCompanyModal && <CreateCompanyAsPartnerModal open={openCompanyModal} setOpen={setOpenCompanyModal} />}

      <div className='flex flex-grow flex-col gap-4'>
        <div className='flex justify-between gap-2'>
          <SearchBarWithFilter filter={filter} items={allItems} setItems={setItems} />
          <div className='flex gap-2'>
            <AddButton
              text={t(TranslationKey.createCompany).singular.label}
              onClick={() => setOpenCompanyModal(true)}
            />
            <Button
              text={t(TranslationKey.linkCompany).singular.label}
              leading={<Icon size={'size-5'} type={IconType.link} />}
              onClick={() => setOpenCreateModal(true)}
            />
          </div>
        </div>

        <div className='flex flex-wrap gap-4 overflow-y-auto p-2'>
          {items.map(item => {
            const company = companies.get(item.companyId);
            if (!company) return null;

            return (
              <PartnerCard
                key={item.id}
                item={item}
                company={company}
                onClick={() => {
                  setSelected(item);
                  setOpenUpdateModal(true);
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
